const FETCH_USERS_LIST = 'FETCH_USERS_LIST';
const FETCH_DEFAULT_DATA = 'FETCH_DEFAULT_DATA';
const FETCH_GROUPS_LIST = 'FETCH_GROUPS_LIST';
const FETCH_GROUP_TYPE = 'FETCH_GROUP_TYPE';
const ADD_EMPLOYEE = 'ADD_EMPLOYEE';
const FETCH_VIEW_REPORT='FETCH_VIEW_REPORT';
const FETCH_REWARD_REPORT='FETCH_REWARD_REPORT';
const FAILD_MESSAGE='FAILD_MESSAGE';
const FAILD_MESSAGE_ADD_EMPLYEE='FAILD_MESSAGE_ADD_EMPLYEE';
const FETCH_GROUPS_VIEW_LIST='FETCH_GROUPS_VIEW_LIST';
const FETCH_ORG_LIST ='FETCH_ORG_LIST';
const FETCH_CUSTOMER_LIST='FETCH_CUSTOMER_LIST';
const FETCH_CUSTDETAIL_LIST='FETCH_CUSTDETAIL_LIST';
const FETCH_All_Account_Manager='FETCH_All_Account_Manager';
const FETCH_Muvi_Account_Manager='FETCH_Muvi_Account_Manager';
const FETCH_All_Muvi_Six='FETCH_All_Muvi_Six';
const FETCH_Muvi_Six_Customer='FETCH_Muvi_Six_Customer';
const FETCH_Customers_For_Search='FETCH_Customers_For_Search';
const FETCH_Muvi_Six_Customer_SearchHandler='FETCH_Muvi_Six_Customer_SearchHandler';
const FETCH_Load_More='FETCH_Load_More';
const FETCH_Load_More1='FETCH_Load_More1';
const FETCH_Pagination_Handel='FETCH_Pagination_Handel';
const FETCH_Muvi6_Login='FETCH_Muvi6_Login';
const FETCH_Assign_Acc='FETCH_Assign_Acc';
const FETCH_Save_Account_Manager='FETCH_Save_Account_Manager';
const FETCH_Savepassword='FETCH_Savepassword';
const FETCH_CancelAccountMuvi5='FETCH_CancelAccountMuvi5';
const FETCH_Raise_Invoice='FETCH_Raise_Invoice';
const FETCH_Product_By_Key='FETCH_Product_By_Key';
const FETCH_Muvi_Classic_Count='FETCH_Muvi_Classic_Count';
//const NEW_POST = 'NEW_POST';

export { 
    FETCH_USERS_LIST , 
    FETCH_DEFAULT_DATA , 
    FETCH_GROUPS_LIST ,
     FETCH_GROUP_TYPE , 
     ADD_EMPLOYEE,
     FETCH_VIEW_REPORT,
     FETCH_REWARD_REPORT, 
     FAILD_MESSAGE,
     FAILD_MESSAGE_ADD_EMPLYEE,
     FETCH_GROUPS_VIEW_LIST,
     FETCH_ORG_LIST,
     FETCH_CUSTOMER_LIST,
     FETCH_CUSTDETAIL_LIST,
     FETCH_All_Account_Manager,
     FETCH_Muvi_Account_Manager,
     FETCH_All_Muvi_Six,
     FETCH_Muvi_Six_Customer,
     FETCH_Customers_For_Search,
     FETCH_Muvi_Six_Customer_SearchHandler,
     FETCH_Load_More,
     FETCH_Load_More1,
     FETCH_Pagination_Handel,
     FETCH_Muvi6_Login,
     FETCH_Assign_Acc,
     FETCH_Save_Account_Manager,
     FETCH_Savepassword,
     FETCH_CancelAccountMuvi5,
     FETCH_Raise_Invoice,
     FETCH_Product_By_Key,
     FETCH_Muvi_Classic_Count
    };


// WEBPACK FOOTER //
// ./src/actions/type.js